import { Store } from '@/Core/Models/Stores'
import { Component, MapAction, MapGetter, Vue, Watch } from 'types-vue'


@Component
export default class InProgress extends Vue {


  /**
   * STORE
   */

  @MapAction(Store.ReportsHistorical) private processUrlQueryParams: (queryParams: any) => Promise<any>
  @MapAction(Store.ReportsHistorical) private newPageSize: (pageSize: number) => number


  @MapGetter(Store.ReportsHistorical) protected listLoading: boolean
  @MapGetter(Store.ReportsHistorical) protected pageSize: number
  @MapGetter(Store.ReportsHistorical) protected totalElements: number


  /**
   * METHODS
   */
  private goToPageOne() {
    if (this.$route.query.page !== '1') {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, page: '1' }})
    }
  }

  /**
   * EVENTS
   */

  protected async onChangePageSize(pageSize: number) {
    this.newPageSize(pageSize)
    this.goToPageOne()
  }



  /**
   * WATCHERS
   */

  @Watch('$route.query', { deep: true, immediate: true })
  protected async onChangeQueryParams() {
    await this.processUrlQueryParams(this.$route.query)
  }
}